import axios from 'axios'

const state = {

};

const getters = {

};

const actions = {

    getSubjectsConstants: async () => {
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_INTRANET_API_URL + "form/subjects", {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                resolve(response.data.data);
            })
            .catch((error) => reject(error));
        });
    },

}

const mutations = {

};

export default {
    state,
    getters,
    actions,
    mutations
};